'use strict';

const React = require('react/addons'),
    {t} = require('services/i18nextWrapper'),
    Router = require('react-router'),
    apiAppUrl = process.env.URL_API,
    mui = require('material-ui'),
    { Route, RouteHandler, Link } = Router,
    { RaisedButton} = mui;

var Contact = React.createClass({displayName: "Contact",

    render: function () {
        return (
            React.createElement("div", {className: "preactivated-page-container jumbotron"}, 
                React.createElement("div", {className: "container text-center"}, 
                    React.createElement("h1", {className: "light"}, t('contact_us_title')), 
                    React.createElement("p", null, t('contact_us_title')), 
                    React.createElement("a", {href: "mailto:support@brewplanner.com?Subject=Need%20help", 
                       target: "_top"}, "support@brewplanner.com"), 
                    React.createElement("br", null), 
                    React.createElement("br", null), 
                    React.createElement("br", null), 
                    React.createElement("span", {className: "text-center"}, 
                    React.createElement("p", null, t('confirm_new_password_static_page_greeting')), 
                        React.createElement("a", {className: "text-left", href: "http://www.brewplanner.com", target: "_top"}, "Brewplanner.com")
                    )
                )
            )
        );
    }
});

module.exports = Contact;



/** WEBPACK FOOTER **
 ** ./src/views/Contact/Contact.jsx
 **/